<div class="info-container">
  <div
    #tooltip="matTooltip"
    (click)="tooltip.toggle()"
    matTooltip="{{ text }}"
    matTooltipPosition="above"
    class="info"
  >
    <img
      style="-webkit-touch-callout: none"
      src="../../../../../assets/img/info.svg"
      alt="info"
    />
  </div>
</div>
